import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  toolName?: string
}

interface State {
  hasError: boolean
  error: string | null
}

/**
 * Error boundary that catches crashes inside tool renderer components.
 * Prevents a broken tool card from taking down the entire chat view.
 */
export class ToolErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error: error.message }
  }

  componentDidCatch(error: Error, info: { componentStack: string }) {
    console.error(`[ToolErrorBoundary] ${this.props.toolName ?? 'unknown'} crashed:`, error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="tool-error-boundary">
          <span className="tool-error-icon">⚠</span>
          <span className="tool-error-text">
            {this.props.toolName
              ? `Kunne ikke vise ${this.props.toolName}-kortet`
              : 'Kunne ikke vise innholdet'}
          </span>
        </div>
      )
    }
    return this.props.children
  }
}
